import React, { useState,useEffect } from "react";
import "./styles.css";
const RadioGroupContext = React.createContext(null);
/**
 * @name UIRadioGroup
 * @function
 * @param {STRING|NUMBER|NULL} value - what value to set in the input as a default
 * @param {Function} onChange - (STRING|NUMBER->VOID) Call back function for when an option is selected
 * @extends React.Component
 * @exported true
 * @description The main component for a UIRadioGroup
 * @example
 *  let onChange = (value)=>{
 *                  console.log(value)    
 *              }
 *  ...
 *           <UIRadioGroup value="1" onChange={onChange}> 
 *             <UIRadio value="1" label="one">
 *              <UIRadio label="two">
 *          </UIRadioGroup>
 *     
 *  
 */
export default function UIRadioGroup(props) {
  const label = props.label ?? "";
  const direction = props.direction ?? "vertical";
  const directionClass = direction === "horizontal" && "horizontal-group";
  const flexDirection = direction === "vertical" ? "flex-vertical" : "flex-horizontal";

  const [value ,setValue] = useState(props.value);
  const controller = {
    //compares the value of the item and existing items from prop.children to see which one to pass to selected Item. 
    "selectRadio" : value => {
      setValue(value);

      if(props.onChange instanceof Function) {
        props.onChange(value);
      }
    },
    "value": () => value   
  };
// Added useEffect to reset state when the props.value is either undefined or is an empty string
useEffect(() => {
  setValue( props.value);
}, [ props.value ]);
  return(
    <RadioGroupContext.Provider value={controller}>
      <div className={ `ui-radio-group ${ directionClass }` }>
        <label className="ui-radio-group-label">{label}</label>

        <div className={ `flex-container ${ flexDirection }` }>
          { props.children }
        </div>
      </div>
    </RadioGroupContext.Provider>
  );
}

export const useRadioGroup = () => React.useContext(RadioGroupContext);

export function UIRadio(props) {
  const className = props.className ?? "";
  const controller = useRadioGroup();
  const value = props.value ?? props.label; 
  const [getCheck ,setCheck] = useState(props.checked === true) 
 
  // Setting the same name for all the radio buttons in a group makes it so only one radio button can be selected at a time
  const name = props.name ?? null;
  const label = props.label ?? ""; 
  const dataPoint = props.dataPoint ?? "";
  const checkInput = controller !== null ? controller.value() === (value||label):getCheck;
  const onChange = function(){
    if(controller === null){
      setCheck(controller !== null ? ()=>controller.selectRadio(value||label): ()=> props.onChange instanceof Function ? props.onChange(value||label):true)
    } else{
     return controller.selectRadio(value||label)
    }
  };
 
  return(
    <label className={`ui-radio flex-height clickable ${className}`} >
      <input type="radio" value={value} name={name} checked={checkInput} onChange={onChange}/>
      <span className="ui-radio-indicator" data-point={dataPoint}></span>
      <span className="ui-radio-label">{label}</span>
    </label>
  );
}